import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getOdontoDistricts} from '../../services/getOdontoDistricts';
import {UseGetOdontoDistrictsQueryProps} from './types';

export function useGetOdontoDistrictsQuery({enabled, params}: UseGetOdontoDistrictsQueryProps) {
	return useQuery({
		queryKey: [QUERY_KEYS.DISTRICTS_ODONTO, params],
		queryFn: ({signal}) => getOdontoDistricts({signal, ...params}),
		enabled,
		staleTime: 0,
	});
}
